import { render, staticRenderFns } from "./SubEmpresaGestaoContratos.vue?vue&type=template&id=f57a355a&lang=pug"
import script from "./SubEmpresaGestaoContratos.vue?vue&type=script&lang=js"
export * from "./SubEmpresaGestaoContratos.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaGestaoContratos.vue?vue&type=style&index=0&id=f57a355a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports